export const appStoreCopyEn = {
  title: 'Get the Portcierge App',
  lead: 'Use Portcierge on your phone underway—and plan on the web before you sail.',
  cta: 'Download on the App Store',
  redirecting: 'Redirecting to the App Store…',
  notOnIos: 'You can also visit the App Store directly to download the app.',
} as const;
